import * as React from "react";

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", type = "text", ...props }, ref) => {
    const base =
      "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm " +
      "placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 " +
      "disabled:opacity-50";

    return <input ref={ref} type={type} className={`${base} ${className}`} {...props} />;
  }
);

Input.displayName = "Input";
